import React, { Component } from 'react';
import { connect } from 'react-redux';
import {Tag, Modal,Tabs,Checkbox} from 'antd';
import {PropTypes} from 'prop-types';
import  './styleSectionKnowRelevance.css'
const TabPane = Tabs.TabPane;
class Relevance extends Component {
    static contextTypes = {
        router: PropTypes.object.isRequired
    };
    state = {
        tab:'1',
        knows:new Map(),
        issues:new Map(),

        selectedknows:[],
        selectedissues:[],
    }

    componentDidMount(){

    }
    componentWillReceiveProps(nextProps){
        if(nextProps.visible&&!this.props.visible){
            this.setState({
                tab:'1',
                knows:new Map(),
                issues:new Map(),
                selectedknows:[],
                selectedissues:[],
            })
        }
    }
    // shouldComponentUpdate(nextProps,nextState){
    //      return true
    // }
    onClick=(e,deep,item,know,selected)=>{
        if(item.list&&item.list.length){//非末级选中
            let arr=this.state[selected];
            arr[deep]=item.id;
            arr.splice(deep+1);
            this.setState({[selected]:arr})
        }else{                    //末级多选框选中
            let map = this.state[know]
            if(map.has(item.id)){
                map.delete(item.id)
            }else{
                map.set(item.id,item)
            }
            this.setState({[know]:map})
        }

    }
    list=(list,current,deep,know,selected)=>{
        return (
                <div key={deep} className={'knowlist'}>
                    {
                        list&&list.map((item,key)=>
                            <div key={key}
                                 onClick={(e)=>{this.onClick(e,deep,item,know,selected)}}
                                 className={current===item.id?'active':'item'}>
                                {
                                    (!item.list||item.list.length===0)&&
                                    <Checkbox checked={this.state[know].has(item.id)}/>
                                }
                                <lable style={{padding:'0 5px'}}>{item.name}</lable>
                            </div>
                        )
                    }
                </div>
            )
    }
    loopList=(list,current,deep=0,know,selected)=>{
        if(!list.length){return null}

        if(!this.state[selected][deep]&&list[0].list&& list[0].list.length){
                current = current||list[0].id
                this.state[selected][deep]=list[0].id
        }

        let arr = []
        arr.push(this.list(list,current,deep,know,selected))//一个选择框

        let next = list.find((val,key)=>{ return val.id===current})
        next = next&&next.list
        if(next&&next.length){
            arr.push(
            this.loopList(next,this.state[selected][deep+1],deep+1,know,selected)
            )
        }
        return arr;

    }
    addRelevance=()=>{
        let arr = []
        this.state.knows.forEach((d,key)=>{arr.push(key)})
        this.state.issues.forEach((d,key)=>{arr.push(key)})
        this.props.onOk(arr)
    }
    render() {

        return (
            <div>
                <Modal width={1000}
                    title={'添加知识点关系'}
                    visible={ this.props.visible}
                    onOk={ this.addRelevance }
                    onCancel={ ()=>{this.props.onCancel()} }
                >
                    <Tabs activeKey={this.state.tab} onChange={(val)=>{this.setState({tab:val})}}>
                        <TabPane tab="知识点" key="1">
                            <div style={{marginBottom:'15px'}}>
                                <span>已选：</span>
                                <span>
                                  {
                                      [...this.state.knows].map((d,key)=>
                                          <Tag key={key} color="#87d068" style={{margin:'3px'}}>{d[1].name}</Tag>
                                      )
                                  }
                                </span>

                            </div>
                            <div>
                                {this.loopList(this.props.data.knowTree,this.state.selectedknows[0],0,'knows','selectedknows')}
                            </div>

                        </TabPane>
                        <TabPane tab="考点" key="2">
                            <div style={{marginBottom:'15px'}}>
                                <span>已选：</span>
                                <span>
                                  {
                                      [...this.state.issues].map((d,key)=>
                                          <Tag key={key} color="#87d068" style={{margin:'3px'}}>{d[1].name}</Tag>
                                      )
                                  }
                                </span>

                            </div>
                            <div>
                                {this.loopList(this.props.data.issueTree,this.state.selectedissues[0],0,'issues','selectedissues')}
                            </div>
                        </TabPane>
                    </Tabs>

                </Modal>

            </div>
        )
    }
}

function mapState(state) {
    return {
        user:state.user
    };
}

function mapDispatch(dispatch) {
    return{

    }
}
export default connect(mapState, mapDispatch)(Relevance);


// WEBPACK FOOTER //
// ./src/entry_app/knowledge_assist/assist/SectionKnowRelevance.js